import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
    const { isDarkMode, toggleTheme } = useTheme();

    return (
        <Tooltip
            title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            arrow
            enterDelay={500}
            leaveDelay={200}
        >
            <IconButton
                onClick={toggleTheme}
                size="small"
                sx={{
                    width: 36,
                    height: 36,
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    backgroundColor: (theme) => theme.palette.action.hover,
                    color: (theme) => theme.palette.text.primary,
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        borderColor: (theme) => theme.palette.primary.main,
                    },
                    '&:active': {
                        transform: 'scale(0.95)',
                    },
                    transition: 'all 0.2s ease-in-out',
                }}
            >
                {isDarkMode ? <Brightness7 fontSize="small" /> : <Brightness4 fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle; 